/**
 * Integration Statistics Cards
 * 
 * Overview cards showing integration statistics and health metrics
 */

import React from 'react'
import { CheckCircle, AlertTriangle, RefreshCw, Zap } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

interface IntegrationStatsCardsProps {
  stats: {
    total: number
    connected: number
    errors: number
    syncing: number
  }
}

export function IntegrationStatsCards({ stats }: IntegrationStatsCardsProps) {
  const cards = [
    {
      title: 'Total Integrations',
      value: stats.total,
      icon: Zap,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      description: 'Active integrations',
    },
    {
      title: 'Connected',
      value: stats.connected,
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      description: 'Working properly',
    },
    {
      title: 'Syncing',
      value: stats.syncing,
      icon: RefreshCw,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      description: 'Currently syncing',
    },
    {
      title: 'Errors',
      value: stats.errors,
      icon: AlertTriangle,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      description: 'Need attention',
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => {
        const Icon = card.icon
        return (
          <Card key={index} className="border-0 shadow-sm">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-muted-foreground">
                    {card.title}
                  </p>
                  <p className="text-2xl font-bold">
                    {card.value}
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {card.description}
                  </p>
                </div>
                <div className={`${card.bgColor} p-3 rounded-full`}>
                  <Icon className={`w-6 h-6 ${card.color}`} />
                </div>
              </div>
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}